import { render } from "./Menu.vue?vue&type=template&id=e7a39caa&ts=true"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import exportComponent from "/home/gitlab-deployer/builds/Bp7u02vYG/0/erp/pay/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__